export const FETCH_USER_INFO_STARTED = "FETCH_USER_INFO_STARTED";
export const FETCH_SINGLE_SME_PROFILES_STARTED = "FETCH_SINGLE_SME_PROFILES_STARTED";
export const FETCH_SINGLE_SME_PROFILES_SUCCEEEDED = "FETCH_SINGLE_SME_PROFILES_SUCCEEEDED";
export const FETCH_SINGLE_SME_PROFILES_FAILED = "FETCH_SINGLE_SME_PROFILES_FAILED";
export const FETCH_USER_INFO_SUCEEDED = "FETCH_USER_INFO_SUCEEDED";
export const FETCH_USER_INFO_FAILED = "FETCH_USER_INFO_FAILED";
export const FETCH_ACC_BALANCE_STARTED = "FETCH_ACC_BALANCE_STARTED";
export const FETCH_ACC_BALANCE_SUCCEDEED = "FETCH_ACC_BALANCE_SUCCEDEED";
export const FETCH_ACC_BALANCE_FAILED = "FETCH_ACC_BALANCE_FAILED";
export const TOGGLE_BALANCE_DISPLAY = "TOGGLE_BALANCE_DISPLAY";
export const ADD_SIGNATORY_STARTED = "ADD_SIGNATORY_STARTED";
export const ADD_SIGNATORY_SUCCEEDED = "ADD_SIGNATORY_SUCCEEDED";
export const ADD_SIGNATORY_FAILED = "ADD_SIGNATORY_FAILED";
export const SET_SIGNATORY_OBJ = "SET_SIGNATORY_OBJ";
export const SET_STATE_DATA = "SET_STATE_DATA";
export const SET_LGA = "SET_LGA";
export const UPDATE_SME_PROFILE_STARTED = "UPDATE_SME_PROFILE_STARTED";
export const UPDATE_SME_PROFILE_SUCCEEDED = "UPDATE_SME_PROFILE_SUCCEEDED";
export const UPDATE_SME_PROFILE_FAILED = "UPDATE_SME_PROFILE_FAILED";
export const INCREASE_STEP = "INCREASE_STEP";
export const SHOW_PHONE_COMPONENT = "SHOW_PHONE_COMPONENT";
export const SHOW_ADDRESS_COMPONENT = "SHOW_ADDRESS_COMPONENT";
export const SHOW_KIN_COMPONENT = "SHOW_KIN_COMPONENT";
export const SHOW_COMPANY_PROFILE_COMPONENT = "SHOW_COMPANY_PROFILE_COMPONENT";
export const RESET_STEPS = "RESET_STEPS";
export const CREATE_WITH_ACC_INFO_START = "CREATE_WITH_ACC_INFO_START";
export const CREATE_WITH_ACC_INFO_SUCCESS = "CREATE_WITH_ACC_INFO_SUCCESS";
export const CREATE_WITH_ACC_INFO_FAILED = "CREATE_WITH_ACC_INFO_FAILED";
export const SELECT_SME_PROFILE = "SELECT_SME_PROFILE";
export const UPDATE_PIN_STATE = "UPDATE_PIN_STATE";
export const CREATE_BENEFICIARY_STARTED = "CREATE_BENEFICIARY_STARTED";
export const CREATE_BENEFICIARY_SUCEEDED = "CREATE_BENEFICIARY_SUCEEDED";
export const CREATE_BENEFICIARY_FAILED = "CREATE_BENEFICIARY_FAILED";
export const UPLOAD_LIMITED_DOCS_STARTED = "UPLOAD_LIMITED_DOCS_STARTED";
export const UPLOAD_LIMITED_DOCS_SUCEEDED = "UPLOAD_LIMITED_DOCS_SUCEEDED";
export const UPLOAD_LIMITED_DOCS_FAILED = "UPLOAD_LIMITED_DOCS_FAILED";
export const UPLOAD_BUSINESS_DOCS_STARTED = "UPLOAD_BUSINESS_DOCS_STARTED";
export const UPLOAD_BUSINESS_DOCS_SUCEDEED = "UPLOAD_BUSINESS_DOCS_SUCEDEED";
export const UPLOAD_BUSINESS_DOCS_FAILED = "UPLOAD_BUSINESS_DOCS_FAILED";
export const CHANGE_PROFILE_PHOTO_STARTED = "CHANGE_PROFILE_PHOTO_STARTED";
export const CHANGE_PROFILE_PHOTO_SUCEEDED = "CHANGE_PROFILE_PHOTO_SUCEEDED";
export const CHANGE_PROFILE_PHOTO_FAILED = "CHANGE_PROFILE_PHOTO_FAILED";
export const CREATE_TRAN_PIN_STARTED = "CREATE_TRAN_PIN_STARTED";
export const CREATE_TRAN_PIN_SUCEEDED = "CREATE_TRAN_PIN_SUCEEDED";
export const CREATE_TRAN_PIN_FAILED = "CREATE_TRAN_PIN_FAILED";
export const UPDATE_INDUSTRY_STARTED = "UPDATE_INDUSTRY_STARTED";
export const UPDATE_INDUSTRY_SUCCEEDED = "UPDATE_INDUSTRY_SUCCEEDED";
export const UPDATE_INDUSTRY_FAILED = "UPDATE_INDUSTRY_FAILED";
export const SET_INDUSTRY = "SET_INDUSTRY";
export const SET_SIGNATORY_DATA = "SET_SIGNATORY_DATA";
export const UPDATE_SIGNATORY_STARTED = "UPDATE_SIGNATORY_STARTED";
export const UPDATE_SIGNATORY_SUCCEEDED = "UPDATE_SIGNATORY_SUCCEEDED";
export const UPDATE_SIGNATORY_FAILED = "UPDATE_SIGNATORY_FAILED";
export const SET_COMPANY_DETAILS = "SET_COMPANY_DETAILS";
export const SET_GET_TO_KNOW_YOU = "SET_GET_TO_KNOW_YOU";
export const CREATE_KUDA_ACCOUNT_STARTED = "CREATE_KUDA_ACCOUNT_STARTED";
export const CREATE_KUDA_ACCOUNT_SUCCEEDED = "CREATE_KUDA_ACCOUNT_SUCCEEDED";
export const CREATE_KUDA_ACCOUNT_FAILED = "CREATE_KUDA_ACCOUNT_FAILED";
export const HIDE_ERROR_MODAL = "HIDE_ERROR_MODAL";
export const REFRESH_PAYMENT_BALANCE_STARTED = "REFRESH_PAYMENT_BALANCE_STARTED";
export const REFRESH_PAYMENT_BALANCE_SUCCESS = "REFRESH_PAYMENT_BALANCE_SUCCESS";
export const REFRESH_PAYMENT_BALANCE_FAILED = "REFRESH_PAYMENT_BALANCE_FAILED";
export const SET_SCUML_FILE = "SET_SCUML_FILE";
export const APPROVE_INDEMNITY_LOADING = "APPROVE_INDEMNITY_LOADING";
export const APPROVE_INDEMNITY_SUCCEEDED = "APPROVE_INDEMNITY_SUCCEEDED";
export const APPROVE_INDEMNITY_FAILED = "APPROVE_INDEMNITY_FAILED";
export const SHOW_INDEMNITY_ACCEPTED_MODAL = "SHOW_INDEMNITY_ACCEPTED_MODAL";
export const CLOSE_INDEMNITY_ACCEPTED_MODAL = "CLOSE_INDEMNITY_ACCEPTED_MODAL";
export const GET_STATEMENT_STARTED = "GET_STATEMENT_STARTED";
export const GET_STATEMENT_SUCCEEDED = "GET_STATEMENT_SUCCEEDED";
export const GET_STATEMENT_FAILED = "GET_STATEMENT_FAILED";
export const VERIFY_PHONENUMBER_STARTED = "VERIFY_PHONENUMBER_STARTED";
export const VERIFY_PHONENUMBER_SUCCEEDED = "VERIFY_PHONENUMBER_SUCCEEDED";
export const VERIFY_PHONENUMBER_FAILED = "VERIFY_PHONENUMBER_FAILED";
export const VALIDATE_USER_PHONENUMBER = "VALIDATE_USER_PHONENUMBER";
export const USER_PHONENUMBER_CHANGE_STARTED = "USER_PHONENUMBER_CHANGE_STARTED";
export const USER_PHONENUMBER_CHANGE_SUCCEEDED = "USER_PHONENUMBER_CHANGE_SUCCEEDED";
export const USER_PHONENUMBER_CHANGE_FAILED = " USER_PHONENUMBER_CHANGE_FAILED";
export const NOK_UPDATE_STARTED = "NOK_UPDATE_STARTED";
export const NOK_UPDATE_SUCCEEDED = "NOK_UPDATE_SUCCEEDED";
export const NOK_UPDATE_FAILED = "NOK_UPDATE_FAILED";
export const SET_USER_NOK_RELATIONSHIP = "SET_USER_NOK_RELATIONSHIP";
export const USER_INFO_UPDATE_STARTED = "USER_INFO_UPDATE_STARTED";
export const USER_INFO_UPDATE_SUCCEEDED = "USER_INFO_UPDATE_SUCCEEDED";
export const USER_INFO_UPDATE_FAILED = "USER_INFO_UPDATE_FAILED";
export const USER_ADDRESS_UPDATE_STARTED = "USER_ADDRESS_UPDATE_STARTED";
export const USER_ADDRESS_UPDATE_SUCCEEDED = "USER_ADDRESS_UPDATE_SUCCEEDED";
export const USER_ADDRESS_UPDATE_FAILED = "USER_ADDRESS_UPDATE_FAILED";
export const CHANGE_USER_PROFILE_PHOTO_STARTED = "CHANGE_USER_PROFILE_PHOTO_STARTED";
export const CHANGE_USER_PROFILE_PHOTO_SUCCEEDED = "CHANGE_USER_PROFILE_PHOTO_SUCCEEDED";
export const CHANGE_USER_PROFILE_PHOTO_FAILED = "CHANGE_USER_PROFILE_PHOTO_FAILED";
export const UPDATE_BUSINESS_EMAIL_STARTED = "UPDATE_BUSINESS_EMAIL_STARTED";
export const UPDATE_BUSINESS_EMAIL_SUCCEEDED = "UPDATE_BUSINESS_EMAIL_SUCCEEDED";
export const UPDATE_BUSINESS_EMAIL_FAILED = "UPDATE_BUSINESS_EMAIL_FAILED";
export const VERIFY_BUSINESS_EMAIL_STARTED = "VERIFY_BUSINESS_EMAIL_STARTED";
export const VERIFY_BUSINESS_EMAIL_SUCCEEDED = "VERIFY_BUSINESS_EMAIL_SUCCEEDED";
export const VERIFY_BUSINESS_EMAIL_FAILED = "VERIFY_BUSINESS_EMAIL_FAILED";
export const SET_LOCAL_IP = "SET_LOCAL_IP";
export const SET_LOCAL_AUDIT_LOG = "SET_LOCAL_AUDIT_LOG";
export const RESET_AUTH_TOKEN_STARTED = "RESET_AUTH_TOKEN_STARTED";
export const RESET_AUTH_TOKEN_SUCCEEDED = "RESET_AUTH_TOKEN_SUCCEEDED";
export const RESET_AUTH_TOKEN_FAILED = "RESET_AUTH_TOKEN_FAILED";
export const KEYCLOAK_LOGOUT_STARTED = "KEYCLOAK_LOGOUT_STARTED";
export const KEYCLOAK_LOGOUT_SUCCEEDED = "KEYCLOAK_LOGOUT_SUCCEEDED";
export const KEYCLOAK_LOGOUT_FAILED = "KEYCLOAK_LOGOUT_FAILED";
export const UPDATE_BUSINESS_TYPE_STARTED = "UPDATE_BUSINESS_TYPE_STARTED";
export const UPDATE_BUSINESS_TYPE_SUCCEEDED = "UPDATE_BUSINESS_TYPE_SUCCEEDED";
export const UPDATE_BUSINESS_TYPE_FAILED = "UPDATE_BUSINESS_TYPE_FAILED";
export const INITIATE_SET_PIN_STARTED = "INITIATE_SET_PIN_STARTED";
export const INITIATE_SET_PIN_SUCCEEDED = "INITIATE_SET_PIN_SUCCEEDED";
export const INITIATE_SET_PIN_FAILED = "INITIATE_SET_PIN_FAILED";
export const UPDATE_SME_BUSINESS_ADDRESS_STARTED = "UPDATE_SME_BUSINESS_ADDRESS_STARTED";
export const UPDATE_SME_BUSINESS_ADDRESS_SUCCEEDED = "UPDATE_SME_BUSINESS_ADDRESS_SUCCEEDED";
export const UPDATE_SME_BUSINESS_ADDRESS_FAILED = "UPDATE_SME_BUSINESS_ADDRESS_FAILED";
export const UPDATE_CAC_TIN_STARTED = "UPDATE_CAC_TIN_STARTED";
export const UPDATE_CAC_TIN_SUCCEEDED = "UPDATE_CAC_TIN_SUCCEEDED";
export const UPDATE_CAC_TIN_FAILED = "UPDATE_CAC_TIN_FAILED";
export const UPDATE_CHECKS = "UPDATE_CHECKS";
export const PREFILL_LIMITED_DOCUMENTS = "PREFILL_LIMITED_DOCUMENTS";
export const PREFILL_BUSINESS_DOCUMENTS = "PREFILL_BUSINESS_DOCUMENTS";
export const UPDATE_BUSINESS_NAME = "UPDATE_BUSINESS_NAME";

// TENTATIVE TYPES
export const SHOW_TRANSACTION_PIN_MODAL = "SHOW_TRANSACTION_PIN_MODAL";
export const SET_TERMS_STATUS = "SET_TERMS_STATUS";
export const UPDATE_CAC_DOC = "UPDATE_CAC_DOC";
export const UPDATE_OTHER_DOC = "UPDATE_OTHER_DOC";
export const TRANSACTION_PIN_DONE = "TRANSACTION_PIN_DONE";

//V2 types
export const VALIDATE_TOKEN_AND_CREATE_STARTED = "VALIDATE_TOKEN_AND_CREATE_STARTED";
export const VALIDATE_TOKEN_AND_CREATE_SUCCEEDED = "VALIDATE_TOKEN_AND_CREATE_SUCCEEDED";
export const VALIDATE_TOKEN_AND_CREATE_FAILED = "VALIDATE_TOKEN_AND_CREATE_FAILED";
export const VALIDATE_TOKEN_AND_CREATE_PROFILE_STARTED = "VALIDATE_TOKEN_AND_CREATE_PROFILE_STARTED";
export const VALIDATE_TOKEN_AND_CREATE_PROFILE_SUCCEEDED = "VALIDATE_TOKEN_AND_CREATE_PROFILE_SUCCEEDED";
export const VALIDATE_TOKEN_AND_CREATE_PROFILE_FAILED = "VALIDATE_TOKEN_AND_CREATE_PROFILE_FAILED";
export const SET_ACCOUNT_SELECTED_STARTED = "SET_ACCOUNT_SELECTED_STARTED";
export const SET_ACCOUNT_SELECTED_SUCCEEDED = "SET_ACCOUNT_SELECTED_SUCCEEDED";
export const SET_ACCOUNT_SELECTED_FAILED = "SET_ACCOUNT_SELECTED_FAILED";
export const UPDATE_BUSINESS_DETAILS_STARTED = "UPDATE_BUSINESS_DETAILS_STARTED";
export const UPDATE_BUSINESS_DETAILS_SUCCEEDED = "UPDATE_BUSINESS_DETAILS_SUCCEEDED";
export const UPDATE_BUSINESS_DETAILS_FAILED = "UPDATE_BUSINESS_DETAILS_FAILED";
export const UPDATE_TIN_NUMBER_STARTED = "UPDATE_TIN_NUMBER_STARTED";
export const UPDATE_TIN_NUMBER_SUCCEEDED = "UPDATE_TIN_NUMBER_SUCCEEDED";
export const UPDATE_TIN_NUMBER_FAILED = "UPDATE_TIN_NUMBER_FAILED";
export const UPDATE_CACDOCSTATE_UPDATE_STARTED = "UPDATE_CACDOCSTATE_UPDATE_STARTED";
export const UPDATE_CACDOCSTATE_UPDATE_SUCCEEDED = "UPDATE_CACDOCSTATE_UPDATE_SUCCEEDED";
export const UPDATE_CACDOCSTATE_UPDATE_FAILED = "UPDATE_CACDOCSTATE_UPDATE_FAILED";
export const CLOSE_START_BANKING_MODAL = "CLOSE_START_BANKING_MODAL";
export const CREATE_PIN_STARTED = "CREATE_PIN_STARTED";
export const CREATE_PIN_SUCCEEDED = "CREATE_PIN_SUCCEEDED";
export const CREATE_PIN_FAILED = "CREATE_PIN_FAILED";
export const APPROVE_TERMS_STARTED = "APPROVE_TERMS_STARTED";
export const APPROVE_TERMS_SUCCEEDED = "APPROVE_TERMS_SUCCEEDED";
export const APPROVE_TERMS_FAILED = "APPROVE_TERMS_FAILED";
export const APPROVE_LL_BN_INDEMNITY_SUCCEEDED = "APPROVE_LL_BN_INDEMNITY_SUCCEEDED";
export const IS_DIRECTOR_REQUIRED = "IS_DIRECTOR_REQUIRED";
export const UPDATE_IS_DIRECTOR_INDEMNITY_STARTED = "UPDATE_IS_DIRECTOR_INDEMNITY_STARTED";
export const UPDATE_IS_DIRECTOR_INDEMNITY_SUCCEEDED = "UPDATE_IS_DIRECTOR_INDEMNITY_SUCCEEDED";
export const UPDATE_IS_DIRECTOR_INDEMNITY_FAILED = "UPDATE_IS_DIRECTOR_INDEMNITY_FAILED";
export const USER_NOK_INFO_UPDATE_STARTED = "USER_NOK_INFO_UPDATE_STARTED";
export const USER_NOK_INFO_UPDATE_SUCCEEDED = "USER_NOK_INFO_UPDATE_SUCCEEDED";
export const USER_NOK_INFO_UPDATE_FAILED = "USER_NOK_INFO_UPDATE_FAILED";
export const SEND_BUSINESS_EMAIL_TOKEN_STARTED = "SEND_BUSINESS_EMAIL_TOKEN_STARTED";
export const SEND_BUSINESS_EMAIL_TOKEN_SUCCEEDED = "SEND_BUSINESS_EMAIL_TOKEN_SUCCEEDED";
export const SEND_BUSINESS_EMAIL_TOKEN_FAILED = "SEND_BUSINESS_EMAIL_TOKEN_FAILED";
export const VALIDATE_BUSINESS_EMAIL_TOKEN_STARTED = "VALIDATE_BUSINESS_EMAIL_TOKEN_STARTED";
export const VALIDATE_BUSINESS_EMAIL_TOKEN_SUCCEEDED = "VALIDATE_BUSINESS_EMAIL_TOKEN_SUCCEEDED";
export const VALIDATE_BUSINESS_EMAIL_TOKEN_FAILED = "VALIDATE_BUSINESS_EMAIL_TOKEN_FAILED";
export const UPDATE_LEGAL_SEARCH_CHARGE_STATUS = "UPDATE_LEGAL_SEARCH_CHARGE_STATUS";

// --- NTB --- //
export const CREATE_BUSINESS_CATEGORY_STARTED = "CREATE_BUSINESS_CATEGORY_STARTED";
export const CREATE_BUSINESS_CATEGORY_SUCCEEDED = "CREATE_BUSINESS_CATEGORY_SUCCEEDED";
export const CREATE_BUSINESS_CATEGORY_FAILED = "CREATE_BUSINESS_CATEGORY_FAILED";
export const CREATE_BUSINESS_ACCOUNT_STARTED = "CREATE_BUSINESS_ACCOUNT_STARTED";
export const CREATE_BUSINESS_ACCOUNT_SUCCEEDED = "CREATE_BUSINESS_ACCOUNT_SUCCEEDED";
export const CREATE_BUSINESS_ACCOUNT_FAILED = "CREATE_BUSINESS_ACCOUNT_FAILED";
export const NTB_CREATE_ACCOUNT_STARTED = "NTB_CREATE_ACCOUNT_STARTED";
export const NTB_CREATE_ACCOUNT_SUCCEEDED = "NTB_CREATE_ACCOUNT_SUCCEEDED";
export const NTB_CREATE_ACCOUNT_FAILED = "NTB_CREATE_ACCOUNT_FAILED";
export const ADD_BVN_STARTED = "ADD_BVN_STARTED";
export const ADD_BVN_SUCCEEDED = "ADD_BVN_SUCCEEDED";
export const ADD_BVN_FAILED = "ADD_BVN_FAILED";
export const BVN_DOC_FLAG_UPDATE_STARTED = "BVN_DOC_FLAG_UPDATE_STARTED";
export const BVN_DOC_FLAG_UPDATE_SUCCEEDED = "BVN_DOC_FLAG_UPDATE_SUCCEEDED";
export const BVN_DOC_FLAG_UPDATE_FAILED = "BVN_DOC_FLAG_UPDATE_FAILED";
export const UPLOAD_VALID_ID_STARTED = "UPLOAD_VALID_ID_STARTED";
export const UPLOAD_VALID_ID_SUCCEEDED = "UPLOAD_VALID_ID_SUCCEEDED";
export const UPLOAD_VALID_ID_FAILED = "UPLOAD_VALID_ID_FAILED";
export const UPDATE_KUDA_BUSINESS_TIER = "UPDATE_KUDA_BUSINESS_TIER";
export const FETCH_ACC_BALANCE_STARTED_FIRESTORE = "FETCH_ACC_BALANCE_STARTED_FIRESTORE";

//DASHBOARD REDESIGN ENDPOINT
export const FETCH_TRANSACTION_LIMIT_SUCCEEDED = "FETCH_DAILY_TRANSACTION_LIMIT_SUCCEEDED";
export const FETCH_TRANSACTION_LIMIT_FAILED = "FETCH_DAILY_TRANSACTION_LIMIT_FAILED";
export const FETCH_TRANSACTION_LIMIT_LOADING = "FETCH_DAILY_TRANSACTION_LIMIT_LOADING";

export const UPDATE_TRANSACTION_LIMIT_SUCCEEDED = "UPDATE_DAILY_TRANSACTION_LIMIT_SUCCEEDED";
export const UPDATE_TRANSACTION_LIMIT_FAILED = "UPDATE_DAILY_TRANSACTION_LIMIT_FAILED";
export const UPDATE_TRANSACTION_LIMIT_LOADING = "UPDATE_DAILY_TRANSACTION_LIMIT_LOADING";

export const FETCH_DAILY_TRANSACTION_VOLUME_SUCCEEDED = "FETCH_DAILY_TRANSACTION_VOLUME_SUCCEEDED";
export const FETCH_DAILY_TRANSACTION_VOLUME_FAILED = "FETCH_DAILY_TRANSACTION_VOLUME_FAILED";
export const FETCH_DAILY_TRANSACTION_VOLUME_LOADING = "FETCH_DAILY_TRANSACTION_VOLUME_LOADING";

//FRESHCHAT
export const STORE_RESTORE_ID_STARTED = "STORE_RESTORE_ID_STARTED";
export const STORE_RESTORE_ID_SUCCEEDED = " STORE_RESTORE_ID_SUCCEEDED";
export const STORE_RESTORE_ID_FAILED = "STORE_RESTORE_ID_FAILED";

// UPDATE HAS ONBOARDED API
export const SET_ONBOARDED_API = "SET_ONBOARDED_API";
